import { HttpParams } from '@angular/common/http';
import { QueryParams } from '@ngrx/data';
import { Dictionary } from '@ngrx/entity';
import { isArray } from 'lodash-es';

export const getHttpParams = (data: Record<string, any>): HttpParams => {
  let httpParams = new HttpParams();

  Object.keys(data).forEach((key) => {
    if (data[key] instanceof Array) {
      data[key].forEach((item: any) => {
        httpParams = httpParams.append(`${key.toString()}[]`, item);
      });
    } else {
      httpParams = httpParams.append(key.toString(), data[key]);
    }
  });

  return httpParams;
};

export const getQueryParams = (data: QueryParams): QueryParams => {
  let params: Dictionary<any> = {};

  Object.keys(data).forEach((key) => {
    if (isArray(data[key])) {
      if (data[key].length > 1) {
        data[key].forEach((item: any) => {
          if (params[`${key}[]`]) {
            params = {
              ...params,
              [`${key}[]`]: [...params[`${key}[]`], item],
            };
          } else {
            params = {
              ...params,
              [`${key}[]`]: [item],
            };
          }
        });
      } else if (data[key].length === 1) {
        params = { ...params, [key]: data[key][0] };
      }
    } else {
      params = { ...params, [key.toString()]: data[key] };
    }
  });

  return params;
};
